$(".footer__scroll").on("click", function() {
  $("html,body").animate({
    scrollTop: 0
  });
});



// WEBPACK FOOTER //
// ../assets/js/scroll-top.js